module.exports = __webpack_public_path__ + "static/media/gates-of-olympus.1e7f231b.gif";